import Vue from "vue";
const getDefaultState = () => {
  return {
    Mygroupes: [],
    MygroupesArray: [],
    ////////////////
    field: "email",
    whereField: "responsable",
    collection: "groupes",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.Mygroupes = payload;
  },
  SET_MY_GROUP_ARRAY (state, payload) {
    state.MygroupesArray = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
    console.log("Mygroupes state reseted");
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  async GetAll({ commit, dispatch }) {
    
    
    //arrayProjetsDeAnimateur
    let arrayProjetsDeAnimateur = [];
    this.state.Auth.user.projets.forEach(function (item) {
      arrayProjetsDeAnimateur.push(item.id);
    });


    //projetsDesCampagnesActivesEtDelAnimateur
    let projetsDesCampagnesActivesEtDelAnimateur = _.difference(
      arrayProjetsDeAnimateur,
      this.state.Campagnes.ProjetsOfCampagnesActives
    );

    // start requête
    commit("SET_LISTE", []);
    commit("Loading/START_BUSY_STATE", "Mygroupes.store.js", { root: true });

    let elemsTemp = [];
    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.Mygroupes.collection)
      .where(
        this.state.Mygroupes.whereField,
        "==",
        this.state.Auth.user.uid.toString()
      )
      .orderBy("nom_groupe")
      .get()
      .then(
        (snapshot) => {
          snapshot.docChanges().forEach(function (change) {
            commit("SET_LISTE", []);
          });

          snapshot.forEach(function (doc) {
            elemsTemp.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elemsTemp) {
            console.log("No Data Available");
            return false;
          } else {
            /* elems = _.filter(elemsTemp, (v) =>
              _.intersection(
                projetsDesCampagnesActivesEtDelAnimateur,
                v.projectList
              )
            ); */

            elems = _.filter(elemsTemp, function (v) {
              let inter = _.intersection(
                projetsDesCampagnesActivesEtDelAnimateur,
                v.projectList
              );
              if (inter.length > 0) {
                return true;
              }
            });
            
            commit("SET_LISTE", elems);
            let MyGpArray = [];
            elems.forEach(function (item) {
              MyGpArray.push(item.id);
            });
            commit("SET_MY_GROUP_ARRAY", MyGpArray);
            commit("Loading/END_BUSY_STATE", "Mygroupes.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("Loading/END_BUSY_STATE", "Mygroupes.store.js", {
            root: true,
          });
        }
      );
  },
};

const getters = {
  Mygroupes: (state) => {
    return state.Mygroupes;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
